import { render, staticRenderFns } from "./requests.vue?vue&type=template&id=34ba83c8"
import script from "./requests.vue?vue&type=script&lang=js"
export * from "./requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports